import _ from "lodash";
import {
  PROJECT_GROUP_TYPE_DP_EE,
  PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
  PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
  PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT,
  PROJECT_GROUP_TYPE_PERSONAL,
} from "Projects/Constants/stringConstants";
import { PROJECT_TYPE_LABEL_MAP } from "Projects/modules/ProjectModules";
/**
 * This function is used to Calculate the Total score of a criteria
 *
 * It is used for both single and multi levels
 *
 * In multi level, criterionIds = [], Is empty, So we add up highest Mark of all criteria
 *
 * In Single level, criterionIds is not empty, So we calculate for specific ids only
 *
 * @param {*} param0
 * @param {Array} param0.criterionIds - Ids of Criterions
 * @param {Array} param0.criteria - The whole criteria nodes Array of Rubric Assessment
 *
 * @returns {Number} - Total score of whole rubric assessment
 */

const getTotalScore = ({ criteria, criterionIds }) => {
  let filteredCriterions = criteria;

  if (!_.isEmpty(criterionIds)) {
    filteredCriterions = _.filter(criteria, item =>
      _.includes(criterionIds, item?.id)
    );
  }

  return _.reduce(
    filteredCriterions,
    (result, criterion) => {
      result = result + _.toNumber(_.get(criterion, "highestMark", 0));
      return result;
    },
    0
  );
};

/**
 * This function is used to Calculate the Rated score of a criteria
 *
 *
 * It is used for both single and multi levels
 *
 * In multi level, criterionIds = [], Is empty, So we add up highest Mark of all criteria
 *
 * In Single level, criterionIds is not empty, So we calculate for specific ids only
 *
 * @param {*} param0
 * @param {Array} param0.criterionIds - Ids of Criterions
 * @param {Array} param0.ratedCriteria- Array of rated criteria
 *
 * @returns {Number} - Rated score of whole rubric assessment
 */

const getRatedScore = ({ criterionIds, ratedCriteria }) => {
  let criterions = ratedCriteria;

  if (!_.isEmpty(criterionIds)) {
    criterions = _.filter(ratedCriteria, item =>
      _.includes(criterionIds, item?.ibPYPElementId)
    );
  }

  return _.reduce(
    criterions,
    (result, criterion) => {
      const criterionValue = _.get(criterion, "value", null);

      if (!_.isNil(criterionValue) && result.showDash) {
        result.showDash = false;
      }
      result.value = result.value + _.toNumber(criterionValue);

      return result;
    },
    { value: 0, showDash: true }
  );
};

export const getRatedScoreMemoized = _.memoize(getRatedScore, params =>
  JSON.stringify(params)
);

export const getTotalScoreMemoized = _.memoize(getTotalScore, params =>
  JSON.stringify(params)
);

export const getDescriptorModalDetails = ({
  projectGroupType,
  t,
  isFinalGrade,
}) => {
  switch (projectGroupType) {
    case PROJECT_GROUP_TYPE_DP_EE:
      return isFinalGrade
        ? {
            title: t("common:grade_with_label", {
              label: t("project:extended_essay"),
            }),
            firstColumnTitle: t("common:grade"),
            secondColumnTitle: t("common:descriptor"),
          }
        : {
            firstColumnTitle: t("common:level"),
            secondColumnTitle: t("common:descriptor"),
          };
    case PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION:
    case PROJECT_GROUP_TYPE_DP_TOK_ESSAY:
      return isFinalGrade
        ? {
            title: t("common:grade_with_label", {
              label: t(PROJECT_TYPE_LABEL_MAP[projectGroupType]),
            }),
            firstColumnTitle: t("common:grade"),
            secondColumnTitle: t("common:descriptor"),
          }
        : {
            firstColumnTitle: t("common:level"),
            secondColumnTitle: t("common:descriptor"),
          };
    case PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT:
      return isFinalGrade
        ? {
            title: t("common:grade_with_label", {
              label: t(PROJECT_TYPE_LABEL_MAP[projectGroupType]),
            }),
            firstColumnTitle: t("common:grade"),
            secondColumnTitle: t("common:descriptor"),
          }
        : {
            firstColumnTitle: t("project:markband"),
            secondColumnTitle: t("common:descriptor"),
          };
    case PROJECT_GROUP_TYPE_PERSONAL:
      return isFinalGrade
        ? {
            title: t("common:grade_with_label", {
              label: t(PROJECT_TYPE_LABEL_MAP[projectGroupType]),
            }),
            firstColumnTitle: t("common:grade"),
            secondColumnTitle: t("common:descriptor"),
          }
        : {};
    default:
      return {};
  }
};
